import { DialogActions, DialogContent } from '@mui/material'
import Typography from '@mui/material/Typography'
import { useTranslation } from 'react-i18next'
import React from 'react'

import ContainedButton from 'shared/components/Buttons/ContainedButton'

type Props = {
   wholesaleName: string
   handleClose: () => void
}

export default function CooperationExpiredNotification({ wholesaleName, handleClose }: Props) {
   const { t } = useTranslation('NOTIFICATIONS')

   return (
      <>
         <DialogContent>
            <Typography variant="body1">{t('reflinkExpiredText', { wholesaleName })}</Typography>
         </DialogContent>
         <DialogActions>
            <ContainedButton variant="contained" onClick={handleClose}>
               OK
            </ContainedButton>
         </DialogActions>
      </>
   )
}
